import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectTypeFilter = createSelector(
  [(store: RootState) => store.documentsList.typeFilter],
  (value) => value
);
